// extracted by mini-css-extract-plugin
module.exports = {"logo":"Anon_logo_2br4K","row":"Anon_row_ZL32X","column":"Anon_column_3p_Pq","left":"Anon_left_rRB8R","right":"Anon_right_3hH3m","languageChooser":"Anon_languageChooser_3u6-Y"};